import React from 'react'
import AdminInquiryList from '../../components/AdminSideComponents/DashBoardInquiry/AdminInquiryList'

const Inquiry = () => {
  return (
    <div className='bg-[#EEF3F7] p-6'>
      <AdminInquiryList />
    </div>
  )
}

export default Inquiry